import type { Route } from '@angular/router';
import {
  sequentialDeactivateGuards,
  hasStringPathParamCanActivateGuard,
} from '@pct-ng/core/router';
import { dirtyCheckCanDeactivateGuard } from '@pct-ng/feature-dirty-check';
import { showToasterDeactivateGuard } from '@pct-ng/form';

export const exclusionRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('./list/resource-opening-hour-exclusion-list.component').then(
        ({ ResourceOpeningHourExclusionListComponent }) =>
          ResourceOpeningHourExclusionListComponent,
      ),
    pathMatch: 'full',
  },
  {
    path: 'new',
    loadComponent: () =>
      import('./details/resource-opening-hour-exclusion-details.component').then(
        ({ ResourceOpeningHourExclusionDetailsComponent }) =>
          ResourceOpeningHourExclusionDetailsComponent,
      ),
    title: 'PAGES.POI.BREADCRUMB.NEW',
    canDeactivate: [
      sequentialDeactivateGuards([
        dirtyCheckCanDeactivateGuard(),
        showToasterDeactivateGuard('PAGES.RESOURCE_OPENING_HOUR_EXCLUSION.SINGULAR'),
      ]),
    ],
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./details/resource-opening-hour-exclusion-details.component').then(
        ({ ResourceOpeningHourExclusionDetailsComponent }) =>
          ResourceOpeningHourExclusionDetailsComponent,
      ),
    title: 'PAGES.POI.BREADCRUMB.EDIT',
    canActivate: [hasStringPathParamCanActivateGuard('id')],
    canDeactivate: [
      sequentialDeactivateGuards([
        dirtyCheckCanDeactivateGuard(),
        showToasterDeactivateGuard('PAGES.RESOURCE_OPENING_HOUR_EXCLUSION.SINGULAR'),
      ]),
    ],
  },
];
